const isClient = () => typeof window !== "undefined" && typeof document !== "undefined";

export default isClient;
